import React, { useEffect, useRef, useState } from "react";
import ProfileStyles from "./HoverPage.module.scss";
import image1 from "../../images/cardimage1.svg";
import image2 from "../../images/cardimage2.svg";
import image3 from "../../images/cardimage3.svg";
import image4 from "../../images/cardimage4.svg";
import image5 from "../../images/cardimage5.svg";
import image6 from "../../images/cardimage6.svg";
import box from "../../images/cubesgif.gif";
import gif1 from "../../images/hovergfi1.gif";
import gif2 from "../../images/hovergif2.gif";
import gif3 from "../../images/hovergif3.gif";
import gif4 from "../../images/hovergif4.gif";
import gif5 from "../../images/hovergif5.gif";
import gif6 from "../../images/hovergif6.gif";

export default function HoverPage() {
  const [card1Hover, setCard1Hover] = useState(true);
  const [card2Hover, setCard2Hover] = useState(false);
  const [card3Hover, setCard3Hover] = useState(false);
  const [card4Hover, setCard4Hover] = useState(false);
  const [card5Hover, setCard5Hover] = useState(false);
  const [card6Hover, setCard6Hover] = useState(true);
  const windowWidth: any = useRef(window.innerWidth);
  const handleMouseEntered1 = () => {
    setCard1Hover(true);
    setCard2Hover(false);
    setCard3Hover(false);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseEntered2 = () => {
    setCard1Hover(false);
    setCard2Hover(true);
    setCard3Hover(false);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseEntered3 = () => {
    setCard1Hover(false);
    setCard2Hover(false);
    setCard3Hover(true);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseEntered4 = () => {
    setCard4Hover(true);
    setCard5Hover(false);
    setCard6Hover(false);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseEntered5 = () => {
    setCard4Hover(false);
    setCard5Hover(true);
    setCard6Hover(false);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseEntered6 = () => {
    setCard4Hover(false);
    setCard5Hover(false);
    setCard6Hover(true);
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  };
  const handleMouseLeave = () => {
    setCard1Hover(true);
    setCard2Hover(false);
    setCard3Hover(false);
    setCard4Hover(false);
    setCard5Hover(false);
    setCard6Hover(true);
  };

  useEffect(() => {
    if (windowWidth.current < 768) {
      setCard1Hover(true);
      setCard2Hover(true);
      setCard3Hover(true);
      setCard4Hover(true);
      setCard5Hover(true);
      setCard6Hover(true);
      // console.log("windowWidth", windowWidth);
    }
  }, [windowWidth.current]);
  console.log("windowWidth", windowWidth.current);

  return (
    <div className={ProfileStyles.boxwrapper}>
      <div className={ProfileStyles.box}>
        <div className={ProfileStyles.boximage}>
          <img src={box} alt="box" style={{ width: "50%" }} />
        </div>
        <p className={ProfileStyles.heading}>Comprehensive Solutions</p>
        <p className={ProfileStyles.para}>
          To keep your business ahead of the rest
        </p>
      </div>
      <div>
        <div className={ProfileStyles.mobileView}>
          <div className={ProfileStyles.cardsMainWrapper}>
            <div
              className={ProfileStyles.card1}
              style={{
                width: card1Hover
                  ? windowWidth.current < 768
                    ? "95%"
                    : "45%"
                  : "21%",
                transition: "width 0.5s ease",
                background: card1Hover ? "rgba(225, 185, 107, 1)" : "",
              }}
              onMouseEnter={() => {
                handleMouseEntered1();
              }}
              onMouseLeave={() => {
                handleMouseLeave();
              }}
            >
              <div className={ProfileStyles.card1ImageSection}>
                <div className={ProfileStyles.card1leftImage}>
                  <img src={image4} className={ProfileStyles.card1leftimage} />
                </div>
                <div className={ProfileStyles.card1rightImage}>
                  <img
                    src={gif1}
                    className={ProfileStyles.card1rightimage}
                    style={{
                      width: card1Hover ? "100%" : "0%",
                      transition: "width 0.5s ease",
                    }}
                  />
                </div>
              </div>
              <div className={ProfileStyles.card1TextContent}>
                <p className={ProfileStyles.card1Header}>Market Data</p>
                <p className={ProfileStyles.card1Para}>
                  Real-time and historical price feeds, tick data, and order
                  book access across assets like stocks, Government Bonds,
                  Corporate Bonds & ETF & SGB .
                </p>
              </div>
            </div>

            <div
              className={ProfileStyles.card2}
              style={{
                width: card2Hover
                  ? windowWidth.current < 768
                    ? "95%"
                    : "45%"
                  : "21%",
                transition: "width 0.5s ease",
                background: card2Hover ? "rgba(255, 171, 171, 1)" : "",
              }}
              onMouseEnter={() => {
                handleMouseEntered2();
              }}
              onMouseLeave={() => {
                handleMouseLeave();
              }}
            >
              <div className={ProfileStyles.card1ImageSection}>
                <div className={ProfileStyles.card1leftImage}>
                  <img src={image1} className={ProfileStyles.card1leftimage} />
                </div>
                <div className={ProfileStyles.card1rightImage}>
                  <img
                    src={gif6}
                    className={ProfileStyles.card1rightimage}
                    style={{
                      width: card2Hover ? "100%" : "0%",
                      transition: "width 0.5s ease",
                    }}
                  />
                </div>
              </div>
              <div className={ProfileStyles.card1TextContent}>
                <p className={ProfileStyles.card1Header}>Order Management</p>
                <p className={ProfileStyles.card1Para}>
                  Place, modify, cancel orders; use advanced types and execute
                  batch orders.
                </p>
              </div>
            </div>
            <div
              className={ProfileStyles.card3}
              style={{
                width: card3Hover
                  ? windowWidth.current < 768
                    ? "95%"
                    : "45%"
                  : "21%",
                transition: "width 0.5s ease",
                background: card3Hover ? "rgba(206, 212, 244, 1)" : "",
              }}
              onMouseEnter={() => {
                handleMouseEntered3();
              }}
              onMouseLeave={() => {
                handleMouseLeave();
              }}
            >
              <div className={ProfileStyles.card1ImageSection}>
                <div className={ProfileStyles.card1leftImage}>
                  <img src={image3} className={ProfileStyles.card1leftimage} />
                </div>
                <div className={ProfileStyles.card1rightImage}>
                  <img
                    src={gif4}
                    className={ProfileStyles.card1rightimage}
                    style={{
                      width: card3Hover ? "100%" : "0%",
                      transition: "width 0.5s ease",
                    }}
                  />
                </div>
              </div>
              <div className={ProfileStyles.card1TextContent}>
                <p className={ProfileStyles.card1Header}>Account Management</p>
                <p className={ProfileStyles.card1Para}>
                  View portfolio, check balance, and access margin details in
                  real-time.
                </p>
              </div>
            </div>
          </div>
          <div className={ProfileStyles.cardsbottom}>
            <div className={ProfileStyles.cardsMainWrapper}>
              <div
                className={ProfileStyles.card2}
                style={{
                  width: card4Hover
                    ? windowWidth.current < 768
                      ? "95%"
                      : "45%"
                    : "21%",
                  transition: "width 0.5s ease",
                  background: card4Hover ? "rgba(201, 230, 140, 1)" : "",
                }}
                onMouseEnter={() => {
                  handleMouseEntered4();
                }}
                onMouseLeave={() => {
                  handleMouseLeave();
                }}
              >
                <div className={ProfileStyles.card1ImageSection}>
                  <div className={ProfileStyles.card1leftImage}>
                    <img
                      src={image5}
                      className={ProfileStyles.card1leftimage}
                    />
                  </div>
                  <div className={ProfileStyles.card1rightImage}>
                    <img
                      src={gif5}
                      className={ProfileStyles.card1rightimage}
                      style={{
                        width: card4Hover ? "100%" : "0%",
                        transition: "width 0.5s ease",
                      }}
                    />
                  </div>
                </div>
                <div className={ProfileStyles.card1TextContent}>
                  <p className={ProfileStyles.card1Header}>Trading tools</p>
                  <p className={ProfileStyles.card1Para}>
                    Access to technical indicators like Moving
                    Averages,RSI,SIP,Calculator,etc.
                  </p>
                </div>
              </div>
              <div
                className={ProfileStyles.card3}
                style={{
                  width: card5Hover
                    ? windowWidth.current < 768
                      ? "95%"
                      : "45%"
                    : "21%",
                  transition: "width 0.5s ease",
                  background: card5Hover ? " rgba(150, 215, 219, 1)" : "",
                }}
                onMouseEnter={() => {
                  handleMouseEntered5();
                }}
                onMouseLeave={() => {
                  handleMouseLeave();
                }}
              >
                <div className={ProfileStyles.card1ImageSection}>
                  <div className={ProfileStyles.card1leftImage}>
                    <img
                      src={image3}
                      className={ProfileStyles.card1leftimage}
                    />
                  </div>
                  <div className={ProfileStyles.card1rightImage}>
                    <img
                      src={gif3}
                      className={ProfileStyles.card1rightimage}
                      style={{
                        width: card5Hover ? "100%" : "0%",
                        transition: "width 0.5s ease",
                      }}
                    />
                  </div>
                </div>
                <div className={ProfileStyles.card1TextContent}>
                  <p className={ProfileStyles.card1Header}>
                    Notification System
                  </p>
                  <p className={ProfileStyles.card1Para}>
                    Get price alerts,order confirmations, and major market news
                    and updates.
                  </p>
                </div>
              </div>
              <div
                className={ProfileStyles.card1}
                style={{
                  width: card6Hover
                    ? windowWidth.current < 768
                      ? "95%"
                      : "45%"
                    : "21%",
                  transition: "width 0.5s ease",
                  background: card6Hover ? "rgba(242, 138, 226, 1)" : "",
                }}
                onMouseEnter={() => {
                  handleMouseEntered6();
                }}
                onMouseLeave={() => {
                  handleMouseLeave();
                }}
              >
                <div className={ProfileStyles.card1ImageSection}>
                  <div className={ProfileStyles.card1leftImage}>
                    <img
                      src={image6}
                      className={ProfileStyles.card1leftimage}
                    />
                  </div>
                  <div className={ProfileStyles.card1rightImage}>
                    <img
                      src={gif2}
                      className={ProfileStyles.card1rightimage}
                      style={{
                        width: card6Hover ? "100%" : "0%",
                        transition: "width 0.5s ease",
                      }}
                    />
                  </div>
                </div>
                <div className={ProfileStyles.card1TextContent}>
                  <p className={ProfileStyles.card1Header}>Customization</p>
                  <p className={ProfileStyles.card1Para}>
                    Integrate with third-party tools and set up custom webHooks
                    for system intergration.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
}
